import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoadingService } from '../core/services/loader.service';
import { MsalService } from '@azure/msal-angular';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { ContactService } from '../core/services/contact.service';
import { environment } from 'src/environments/environment';
import { LocalService } from '../core/services/local.service';
import { ToasterService } from '../toaster/toaster.service';
import { JWTTokenService } from '../core/services/jwttoken.service';
import { HealthService } from '../core/services/health.service';
import { AlertDialogComponent } from '../pages/dialogs/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';

type State = {
  action: string;
  uri: string;
};

@Component({
  selector: 'app-vendor-consent',
  templateUrl: './vendor-consent.component.html',
  styleUrls: ['./vendor-consent.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VendorConsentComponent implements OnInit {
  pk: any = -1;
  token: any = '';
  consentApproved = false;
  tokenExpired = false;
  constructor(
    private loader: LoadingService,
    private authService: MsalService,
    private localStorage: LocalService,
    private jwtTokenService: JWTTokenService,
    private healthService: HealthService,
    private contactService: ContactService,
    private matDialog: MatDialog,
    private toaster: ToasterService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    console.log('Consent page constructor loaded');
  }
  ngOnInit(): void {
    console.log('Consent page loaded');
    this.route.queryParams.subscribe((param: any) => {
      if (param['queryString'] !== undefined) {
        let decryptQuery = JSON.parse(atob(param['queryString']));
        this.token = decryptQuery['token'];
        this.pk = decryptQuery['pk'];
        this.jwtTokenService.setToken(this.token);
        this.tokenExpired = this.jwtTokenService.isTokenExpired();
      } else {
        this.router.navigateByUrl('/');
      }
    });
  }
  consentApprove() {
    this.loader.show();
    this.contactService.updateConsent(this.pk).subscribe(
      (res) => {
        this.loader.hide();
        this.localStorage.removeData('localUser');
        this.localStorage.removeData('company');
        this.localStorage.removeData('idToken');
        this.localStorage.removeData('role');
        this.localStorage.removeData('policy');
        this.consentApproved = true;
      },
      (error) => {
        this.consentApproved = true;
        this.toaster.show('success', '', 'Something went to wrong. Please contact to Administrator');
        this.loader.hide();
      }
    );
  }
}
